import { useMemo } from "react";
import { useLocation } from "react-router-dom";

const pageTheme = {
  home: {
    wash: "from-royal-blue/10 via-transparent to-warm-gold/10",
    primary: "bg-royal-blue/20",
    secondary: "bg-warm-gold/20",
    tertiary: "bg-cyan-300/30"
  },
  study: {
    wash: "from-indigo-300/15 via-transparent to-royal-blue/10",
    primary: "bg-indigo-300/25",
    secondary: "bg-royal-blue/20",
    tertiary: "bg-warm-gold/18"
  },
  about: {
    wash: "from-royal-blue/12 via-transparent to-sky-300/12",
    primary: "bg-sky-300/26",
    secondary: "bg-royal-blue/20",
    tertiary: "bg-warm-gold/14"
  },
  testimonials: {
    wash: "from-sky-200/20 via-transparent to-blue-300/15",
    primary: "bg-blue-300/25",
    secondary: "bg-sky-300/28",
    tertiary: "bg-warm-gold/14"
  },
  contact: {
    wash: "from-emerald-200/16 via-transparent to-royal-blue/12",
    primary: "bg-emerald-300/23",
    secondary: "bg-royal-blue/20",
    tertiary: "bg-warm-gold/18"
  },
  default: {
    wash: "from-royal-blue/8 via-transparent to-warm-gold/8",
    primary: "bg-royal-blue/16",
    secondary: "bg-warm-gold/16",
    tertiary: "bg-cyan-200/20"
  }
};

function resolveTheme(pathname) {
  if (pathname === "/") return pageTheme.home;
  if (pathname.startsWith("/study-in/")) return pageTheme.study;
  if (pathname.startsWith("/about")) return pageTheme.about;
  if (pathname.startsWith("/testimonials")) return pageTheme.testimonials;
  if (pathname.startsWith("/contact")) return pageTheme.contact;
  return pageTheme.default;
}

function FloatingBackdrop() {
  const { pathname } = useLocation();
  const theme = useMemo(() => resolveTheme(pathname), [pathname]);

  return (
    <div aria-hidden="true" className="pointer-events-none fixed inset-0 z-[1] overflow-hidden">
      <div className={`absolute inset-0 bg-gradient-to-br ${theme.wash}`} />

      <div className={`ambient-orb slow absolute -left-16 top-[16%] h-52 w-52 ${theme.primary}`} />
      <div className={`ambient-orb medium absolute right-[8%] top-[9%] h-40 w-40 ${theme.secondary}`} />
      <div className={`ambient-orb pulse absolute left-[42%] top-[34%] h-24 w-24 ${theme.tertiary}`} />
      <div className={`ambient-orb slow absolute -right-14 bottom-[21%] h-56 w-56 ${theme.primary}`} />
      <div className={`ambient-orb medium absolute left-[12%] bottom-[8%] h-36 w-36 ${theme.secondary}`} />
      <div className={`ambient-orb pulse absolute right-[28%] bottom-[14%] h-20 w-20 ${theme.tertiary}`} />
    </div>
  );
}

export default FloatingBackdrop;
